// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5336 ? "b3a13d7d" : chunkId) + "." + {"1600":"f0d5218552e8285c","1640":"619ab20440a7fb96","5336":"2f338daeeaff69a7","6066":"e25288f0b2288f0b","7003":"f5223378d413a7c4","7623":"6117ace909e35f21"}[chunkId] + ".js";
};